module.exports = __webpack_public_path__ + "static/media/sph-sale-person.0837c992.png";